import React from "react";

export const Button = () => {
  return (
    <section className='button'>
      <button className='button__btn'>Call Us</button>
    </section>
  );
};
